import sharp from 'sharp';
import { ImageFile } from '@adornis/file-utils/db/images.js';
import { readFile } from 'node:fs/promises';

/**
 * Crop an image by region and save as a new ImageFile.
 * @param imageId The original image file ID
 * @param region An object with x1, y1, x2, y2 (in pixels)
 * @returns The new ImageFile instance (saved)
 */
export async function cropAndSaveRegion(imageId: string, region: { x1: number; y1: number; x2: number; y2: number }) {
  // Load original image
  const imageRaw = await ImageFile.getByID(imageId)(ImageFile.allFields);
  if (!imageRaw) throw new Error(`ImageFile not found: ${imageId}`);
  const image = imageRaw instanceof ImageFile ? imageRaw : new ImageFile(imageRaw);
  const buffer = await readFile(image.getFullPath());

  // Get image metadata (height, width, etc.)
  const metadata = await sharp(buffer).metadata();
  const imageHeight = metadata.height;
  const imageWidth = metadata.width;
  // You can also get width: metadata.width;

  let { x1, y1, x2, y2 } = region;

  // Convert normalized coordinates to pixel values
  x1 = Math.round((x1 / 1000) * imageWidth);
  y1 = Math.round((y1 / 1000) * imageHeight);
  x2 = Math.round((x2 / 1000) * imageWidth);
  y2 = Math.round((y2 / 1000) * imageHeight);

  // Crop using sharp
  const croppedBuffer = await sharp(buffer)
    .extract({ left: x1, top: y1, width: x2 - x1, height: y2 - y1 })
    .toBuffer();

  // Save as new ImageFile
  const croppedImage = await ImageFile.createFromBuffer(croppedBuffer, `${imageId}-crop.png`);
  await croppedImage.save();
  return croppedImage;
}
